import React from 'react';
import HelpPanel from '@cloudscape-design/components/help-panel';
import { ExternalLinkGroup } from './common';

export function EventTestingHelp() {
  return (
    <HelpPanel
      header={<h2>Event Testing</h2>}
      footer={
        <ExternalLinkGroup
          items={[
            { href: '#', text: 'Event Types Documentation' },
            { href: '#', text: 'Testing Best Practices' },
            { href: '#', text: 'Notification Pipeline Overview' }
          ]}
        />
      }
    >
      <p>
        The Event Testing page allows you to quickly test email and Slack notifications using mock data. This simplified interface focuses only on the essential fields needed for testing.
      </p>
      
      <h3>Page Layout</h3>
      <p>
        The page is organized in three main sections:
      </p>
      <ol>
        <li><strong>Preview Event Data</strong>: Shows the mock data that will be used for testing</li>
        <li><strong>Test Configuration</strong>: Contains the three editable fields</li>
        <li><strong>Test Actions</strong>: Buttons to trigger tests and see results</li>
      </ol>
      
      <h3>Event Types</h3>
      <p>
        You can test different types of notification events by selecting from the dropdown:
      </p>
      <ul>
        <li><strong>New Deployment</strong>: Simulates a customer deploying an AWS Solution for the first time</li>
        <li><strong>Multiple Solutions</strong>: Simulates a customer deploying multiple AWS Solutions</li>
        <li><strong>Repeat Deployment</strong>: Simulates a customer deploying another instance of a solution they've used before</li>
        <li><strong>Long Term</strong>: Simulates a customer keeping a deployment active for an extended period (6+ months)</li>
      </ul>
      
      <h3>Required Fields</h3>
      <p>
        Only these fields need to be provided:
      </p>
      <ul>
        <li><strong>Event Type</strong>: Select the type of notification to test</li>
        <li><strong>Account Manager Email</strong>: Required for email notifications (where the test email will be sent)</li>
        <li><strong>Account Manager Slack Alias</strong>: Required for Slack notifications (where the Slack message will be directed)</li>
      </ul>
      
      <h3>Mock Data</h3>
      <p>
        All other data fields are automatically populated with mock values:
      </p>
      <ul>
        <li>Customer name: "Acme Corporation"</li>
        <li>Solution name: "AWS Cloud Migration Factory"</li>
        <li>AWS Account ID: A mock account number</li>
        <li>Creation date: Today's date</li>
        <li>Deployment days active: 30</li>
      </ul>
      
      <h3>Testing Options</h3>
      <p>
        You can perform two types of tests:
      </p>
      <ul>
        <li><strong>Send Test Email</strong>: Tests the email notification pipeline (requires Account Manager Email)</li>
        <li><strong>Send Test Slack Message</strong>: Tests the Slack notification pipeline (requires Account Manager Slack Alias)</li>
      </ul>
      
      <h3>Regenerating IDs</h3>
      <p>
        Use the "Regenerate IDs" button to create new unique IDs for the test event if needed.
      </p>
    </HelpPanel>
  );
}
